import moment from "moment";
import {LocalCache} from "oca-lib-web";
import Constants from "./Constants";
import CacheSettings from "./CacheSettings";

export default class DashboardDateUtil {

    public static difference(timeInterval:TimeInterval): number {
        var duration = moment.duration(moment(timeInterval.end).diff(moment(timeInterval.start)));
        let dateInterval = this.getDateInterval(timeInterval.interval);

        if (dateInterval == Constants.DATE_INTERVAL_MONTH) {
            return Math.round(duration.asMonths());
        } else {
            return Math.round(duration.asDays());
        }
    }

    public static getTickDates(timeInterval:TimeInterval) {
        let ticks = [];
        let numberOfIntervals = this.difference(timeInterval);
        let dateInterval = this.getDateInterval(timeInterval.interval);

        for (var i=0; i<numberOfIntervals; i++) {
            if (dateInterval == Constants.DATE_INTERVAL_MONTH) {
                let unitDate = moment(timeInterval.start).add(i, 'months');
                ticks.push(unitDate.format("MMM"));
            } else {
                let unitDate = moment(timeInterval.start).add(i, 'days');
                ticks.push(unitDate.format("DD"));
            }
        }
        return ticks;
    }

    public static getTooltipDates(timeInterval:TimeInterval):Array<string> {
        let dates:Array<string> = [];
        let numberOfIntervals = this.difference(timeInterval);
        let dateInterval = this.getDateInterval(timeInterval.interval);

        for (var i=0; i<numberOfIntervals; i++) {
            if (dateInterval == Constants.DATE_INTERVAL_MONTH) {
                let unitDate = moment(timeInterval.start).add(i, 'months');
                dates.push(unitDate.format("MMM"));
            } else {
                let unitDate = moment(timeInterval.start).add(i, 'days');
                dates.push(unitDate.format("(ddd) MMM DD"));
            }
        }
        return dates;
    }

    public static getDatesForFormat(timeInterval:TimeInterval, format:string):Array<string> {
        let dates:Array<string> = [];
        let numberOfIntervals = this.difference(timeInterval);
        let dateInterval = this.getDateInterval(timeInterval.interval);

        for (var i=0; i<numberOfIntervals; i++) {
            if (dateInterval == Constants.DATE_INTERVAL_MONTH) {
                let unitDate = moment(timeInterval.start).add(i, 'months');
                dates.push(unitDate.format(format));
            } else {
                let unitDate = moment(timeInterval.start).add(i, 'days');
                dates.push(unitDate.format(format));
            }
        }
        return dates;
    }

    public static getTimeInterval(): TimeInterval {
        let startDate = "";
        let endDate = "";
        let dateValue = LocalCache.getLocal(Constants.CACHE_DATE);

        if ("last7days" == dateValue) {
            startDate = moment().subtract(7,'days').format("YYYYMMDD");
            endDate = moment().subtract(0, 'days').format("YYYYMMDD");
        } else if ("last14days" == dateValue) {
            startDate = moment().subtract(14, 'days').format("YYYYMMDD");
            endDate = moment().subtract(0, 'days').format("YYYYMMDD");
        } else if ("thisMonth" == dateValue || !dateValue) {
            startDate = moment().startOf('month').format("YYYYMMDD");
            endDate = moment().subtract(0, 'day').format("YYYYMMDD")
        } else if ("lastMonth" == dateValue) {
            startDate = moment().subtract(1, 'months').startOf('month').format("YYYYMMDD");
            endDate = moment().startOf('month').format("YYYYMMDD")
        } else if ("twoMonths" == dateValue) {
            startDate = moment().subtract(2, 'months').startOf('month').format("YYYYMMDD");
            endDate = moment().subtract(2, 'months').endOf('month').add(1, 'day').format("YYYYMMDD");
        } else if ("last3Months" == dateValue) {
            startDate = moment().subtract(3,'months').startOf('month').format("YYYYMMDD");
            endDate = moment().startOf('month').format("YYYYMMDD");
        } else if ("last6Months" == dateValue) {
            startDate = moment().subtract(6,'months').startOf('month').format("YYYYMMDD");
            endDate = moment().subtract(1, 'day').format("YYYYMMDD");
        } else if ("last12Months" == dateValue) {
            startDate = moment().subtract(12,'months').startOf('month').format("YYYYMMDD");
            endDate = moment().subtract(1, 'day').format("YYYYMMDD");
        } else if ("thisYear" == dateValue) {
            startDate = moment().startOf('year').format("YYYYMMDD");
            endDate = moment().subtract(1, 'day').format("YYYYMMDD");
        } else if ("lastYear" == dateValue) {
            startDate = moment().subtract(1,'year').startOf('year').format("YYYYMMDD");
            endDate = moment().startOf('month').format("YYYYMMDD");
        } else if ("custom" == dateValue) {
            if (CacheSettings.getCustomDate()) {
                let dateList = CacheSettings.getCustomDate().split(",");
                startDate = dateList[0];
                endDate = dateList[1];
            }
        }

        return ({start: startDate, end: endDate, interval: dateValue});
    }

    public static getTimeIntervalString(): string {
        let timeInterval:TimeInterval = this.getTimeInterval();
        let start = moment(timeInterval.start).format("MMM D, YYYY");
        let end = moment(timeInterval.end).subtract(1, 'days').format("MMM D, YYYY");
        return start + " - " + end;
    }

    public static getPreviousTimeInterval(): TimeInterval {
        let startDate = "";
        let endDate = "";
        let dateValue = LocalCache.getLocal(Constants.CACHE_DATE);

        if ("last7days" == dateValue) {
            startDate = moment().subtract(14,'days').format("YYYYMMDD");
            endDate = moment().subtract(7, 'days').format("YYYYMMDD");
        } else if ("last14days" == dateValue) {
            startDate = moment().subtract(28, 'days').format("YYYYMMDD");
            endDate = moment().subtract(14, 'days').format("YYYYMMDD");
        } else if ("thisMonth" == dateValue || !dateValue) {
            startDate = moment().subtract(1, 'months').startOf('month').format("YYYYMMDD");
            endDate = moment().subtract(1, 'months').format("YYYYMMDD")
        } else if ("lastMonth" == dateValue) {
            startDate = moment().subtract(2, 'months').startOf('month').format("YYYYMMDD");
            endDate = moment().subtract(2, 'months').endOf('month').format("YYYYMMDD")
        } else if ("twoMonths" == dateValue) {
            startDate = moment().subtract(3, 'months').startOf('month').format("YYYYMMDD");
            endDate = moment().subtract(3, 'months').endOf('month').format("YYYYMMDD")
        } else if ("last3Months" == dateValue) {
            startDate = moment().subtract(6,'months').startOf('month').format("YYYYMMDD");
            endDate = moment().subtract(3, 'months').endOf('month').format("YYYYMMDD");
        } else if ("last6Months" == dateValue) {
            startDate = moment().subtract(12,'months').startOf('month').format("YYYYMMDD");
            endDate = moment().subtract(6, 'day').endOf('month').format("YYYYMMDD");
        } else if ("last12Months" == dateValue) {
            startDate = moment().subtract(24,'months').startOf('month').format("YYYYMMDD");
            endDate = moment().subtract(12, 'months').endOf('month').format("YYYYMMDD");
        } else if ("thisYear" == dateValue) {
            startDate = moment().startOf('year').format("YYYYMMDD");
            endDate = moment().startOf('month').format("YYYYMMDD");
        } else if ("lastYear" == dateValue) {
            startDate = moment().subtract(2,'years').startOf('year').format("YYYYMMDD");
            endDate = moment().subtract(1, 'years').endOf('month').format("YYYYMMDD");
        } else if ("custom" == dateValue) {
            if (CacheSettings.getCustomDate()) {
                let dateList = CacheSettings.getCustomDate().split(",");
                startDate = dateList[0];
                endDate = dateList[1];
            }
        }

        //console.log("previous time interval");
        //console.log({start: startDate, end: endDate, interval: dateValue});
        return ({start: startDate, end: endDate, interval: dateValue});
    }

    public static getDateInterval(timeInterval:string): string {
        //let dateValue = LocalCache.getLocal(Constants.CACHE_DATE);
        if (timeInterval == "last3Months" || timeInterval == "last6Months" || timeInterval == "last12Months"
            || timeInterval == "thisYear" || timeInterval == "lastYear" || timeInterval == "allTime") {
            return Constants.DATE_INTERVAL_MONTH;
        } else {
            return Constants.DATE_INTERVAL_DAY;
        }
    }

    public static convertFlurryDate(date:string, interval:string) {
        //let dateValue = LocalCache.getLocal(Constants.CACHE_DATE);
        let dateInterval = this.getDateInterval(interval);
        //console.log("CONVERT DATE: ", dateInterval);
        if (dateInterval == Constants.DATE_INTERVAL_MONTH) {
            return moment(date).add(1, "month").format("YYYY-MM") + "-01";
        } else {
            return moment(date).format("YYYY-MM-DD");
        }
    }
}